import GoogleDriveIcon from "../../assets/components/sources/GoogleDriveIcon";

const GoogleDriveLogomark = ({ height }: { height: number }) => {
  return <GoogleDriveIcon height={height} />;
};

export default GoogleDriveLogomark;
